import { useLayoutEffect } from 'react'

/**
 * Freezes document scroll with `overflow: hidden` on <html> and pads the vanished scrollbar away,
 * the way the legacy community modals did.
 *
 * Base UI's dialog scroll lock reserves `scrollbar-gutter: stable` on <html> instead. That gutter
 * narrows every fixed, viewport-sized modal surface, so the post view scrollbar lands next to it
 * and the right-edge band doubles. Base UI leaves a page that is already locked to its owner.
 */
export function useDocumentScrollLock(locked: boolean): void {
  useLayoutEffect(() => {
    if (!locked) {
      return
    }

    const html = document.documentElement
    const previousOverflow = html.style.overflow
    const previousPaddingRight = html.style.paddingRight
    const scrollbarWidth = window.innerWidth - html.clientWidth

    html.style.overflow = 'hidden'

    if (scrollbarWidth > 0) {
      html.style.paddingRight = `${scrollbarWidth}px`
    }

    return () => {
      html.style.overflow = previousOverflow
      html.style.paddingRight = previousPaddingRight
    }
  }, [locked])
}
